export default "__VITE_ASSET__BZtvunBg__"